import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f40c592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-body text-left" }
const _hoisted_2 = { class: "dialog-actions" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

import { ref } from 'vue'
import DialogUI from '@/components/CommonUI/DialogUI.vue'
import NotificationUI from '@/components/CommonUI/NotificationUI.vue'
import { useWorksStore } from '@/store/works'
import { getErrorTitle, getErrorMessage } from '@/helpers/errors'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'TerminateWorkDialog',
  props: {
    workId: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



const dialog = ref<IDialogUI | null>(null)
const errorMessage = ref('')
const errorTitle = ref('')
const isLoading = ref(false)

const workStore = useWorksStore()
const { $gettext } = useGettext()

function show() {
  dialog.value?.show()
}

function hide() {
  dialog.value?.hide()
}

async function terminate() {
  if (!props.workId) return
  isLoading.value = true

  try {
    await workStore.terminateWork(props.workId)
    hide()
  } catch (error) {
    errorTitle.value = getErrorTitle(error)
    errorMessage.value = getErrorMessage(error)
  }

  isLoading.value = false
}

__expose({
  show,
  hide,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogUI, {
    ref_key: "dialog",
    ref: dialog,
    size: "medium"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(_unref($gettext)("Setting this registration to terminated status will result in Ditto Music Publishing’s claim being withdrawn from this work at the society level.")), 1),
        _createElementVNode("p", null, _toDisplayString(_unref($gettext)("You are now free to assign this work to another publisher. If you should wish to reassign this work back to Ditto Music Publishing, please contact our support team so they can reactivate your claim.")), 1),
        _createElementVNode("p", null, _toDisplayString(_unref($gettext)("Are you sure you'd like to proceed?")), 1)
      ]),
      (errorMessage.value || errorTitle.value)
        ? (_openBlock(), _createBlock(NotificationUI, {
            key: 0,
            title: errorTitle.value,
            message: errorMessage.value
          }, null, 8, ["title", "message"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "secondary black full-width",
          type: "button",
          disabled: isLoading.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (hide()))
        }, _toDisplayString(_unref($gettext)("Cancel")), 9, _hoisted_3),
        _createElementVNode("button", {
          class: "terminate-button full-width",
          "data-testid": "confirm-terminate-button",
          type: "button",
          disabled: isLoading.value,
          onClick: terminate
        }, _toDisplayString(_unref($gettext)("Terminate")), 9, _hoisted_4)
      ])
    ]),
    _: 1
  }, 512))
}
}

})